import { Trans } from '~/common/context';
import { Button, Icon } from '@wyz/ui';
import React from 'react';

type AddToCartButtonProps = Pick<
  React.ComponentProps<typeof Button>,
  'disabled' | 'isLoading' | 'id' | 'form'
> & {
  productOrderedQuantity: number;
};

const AddToCartButton = ({
  isLoading,
  disabled,
  productOrderedQuantity,
  ...rest
}: AddToCartButtonProps) => {
  return (
    <Button
      {...rest}
      type='submit'
      variant='primary'
      isLoading={isLoading}
      disabled={disabled}
      size='xs'
    >
      <span className='me-1 add-to-cart-text'>
        <Trans i18nKey='app.common.button.add' />
      </span>
      <Icon icon='shopping-cart' size='xs' />
      {productOrderedQuantity > 0 && (
        <div
          className='position-absolute bg-primary border border-2 border-light rounded-circle fs-xxs d-flex align-items-center justify-content-center'
          style={{
            left: '90%',
            bottom: '70%',
            width: '1.1rem',
            height: '1.1rem',
          }}
        >
          {productOrderedQuantity}
        </div>
      )}
    </Button>
  );
};
export default AddToCartButton;
